// import React, { useState, useEffect } from 'react';
// import './Erpdashbord.css';

// const Dashboard = () => {
//   // State for dynamic data
//   const [kpiData, setKpiData] = useState({
//     totalTransfers: 0,
//     totalValue: 0,
//     openOrders: 0,
//     pendingApprovals: 0
//   });

//   const [inventoryData, setInventoryData] = useState([]);
//   const [financialData, setFinancialData] = useState([]);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedMonth, setSelectedMonth] = useState('July 2026');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('All');

//   // Mock API call - Simulate fetching data
//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       setLoading(true);
      
//       // Simulate API delay
//       setTimeout(() => {
//         // KPI Data
//         setKpiData({
//           totalTransfers: 1247,
//           totalValue: '$2.4M',
//           openOrders: 86,
//           pendingApprovals: 23
//         });

//         // Inventory Data (Monthly Stock Value)
//         setInventoryData([
//           { month: 'Jan', value: 185000 },
//           { month: 'Feb', value: 192000 },
//           { month: 'Mar', value: 178000 },
//           { month: 'Apr', value: 205000 },
//           { month: 'May', value: 215000 },
//           { month: 'Jun', value: 234000 },
//           { month: 'Jul', value: 247000 }
//         ]);

//         // Financial Data (CoGS & Revenue)
//         setFinancialData([
//           { month: 'Jan', cogs: 125000, revenue: 245000 },
//           { month: 'Feb', cogs: 132000, revenue: 258000 },
//           { month: 'Mar', cogs: 118000, revenue: 235000 },
//           { month: 'Apr', cogs: 145000, revenue: 275000 },
//           { month: 'May', cogs: 152000, revenue: 290000 },
//           { month: 'Jun', cogs: 168000, revenue: 312000 },
//           { month: 'Jul', cogs: 175000, revenue: 335000 }
//         ]);

//         // Transaction Data
//         setTransactions([
//           { id: 'TR-1001', outlet: 'Mumbai Central', items: 245, value: '$12,450', status: 'Completed', date: '2026-07-23' },
//           { id: 'TR-1002', outlet: 'Delhi South', items: 189, value: '$8,920', status: 'Pending', date: '2026-07-23' },
//           { id: 'TR-1003', outlet: 'Bangalore East', items: 312, value: '$15,670', status: 'Completed', date: '2026-07-22' },
//           { id: 'TR-1004', outlet: 'Chennai North', items: 156, value: '$7,340', status: 'In Transit', date: '2026-07-22' },
//           { id: 'TR-1005', outlet: 'Hyderabad West', items: 278, value: '$13,280', status: 'Completed', date: '2026-07-21' },
//           { id: 'TR-1006', outlet: 'Pune East', items: 198, value: '$9,450', status: 'Pending', date: '2026-07-21' },
//           { id: 'TR-1007', outlet: 'Ahmedabad North', items: 234, value: '$11,230', status: 'Completed', date: '2026-07-20' },
//         ]);

//         setLoading(false);
//       }, 1500);
//     };

//     fetchDashboardData();
//   }, []);

//   // Handler for filter changes
//   const handleMonthChange = (e) => {
//     setSelectedMonth(e.target.value);
//     // Would trigger API refetch in real app
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     const colors = {
//       'Completed': '#4CAF50',
//       'Pending': '#FF9800',
//       'In Transit': '#2196F3'
//     };
//     return colors[status] || '#666';
//   };

//   // Filter transactions
//   const filteredData = transactions.filter(item => {
//     const matchesSearch = item.outlet.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                           item.id.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesStatus = filterStatus === 'All' || item.status === filterStatus;
//     return matchesSearch && matchesStatus;
//   });

//   // Calculate max values for charts
//   const maxInventoryValue = inventoryData.length > 0 ? Math.max(...inventoryData.map(item => item.value)) : 1;
//   const maxFinancialValue = financialData.length > 0 ? Math.max(...financialData.map(item => Math.max(item.cogs, item.revenue))) : 1;

//   // KPI Card Component
//   const KPICard = ({ title, value, icon, change, changeType }) => {
//     const getChangeColor = () => {
//       if (changeType === 'positive') return '#4CAF50';
//       if (changeType === 'negative') return '#f44336';
//       if (changeType === 'warning') return '#FF9800';
//       return '#666';
//     };

//     const getChangeIcon = () => {
//       if (changeType === 'positive') return '↑';
//       if (changeType === 'negative') return '↓';
//       if (changeType === 'warning') return '⚠';
//       return '';
//     };

//     return (
//       <div className="kpi-card">
//         <div className="kpi-icon">{icon}</div>
//         <div className="kpi-content">
//           <div className="kpi-title">{title}</div>
//           <div className="kpi-value">{value}</div>
//           <div className="kpi-change" style={{ color: getChangeColor() }}>
//             {getChangeIcon()} {change} from last month
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Inventory Chart Component
//   const InventoryChart = () => (
//     <div className="chart-card">
//       <h3>📦 Inventory Value Transferred Out</h3>
//       <div className="bar-chart">
//         {inventoryData.map((item, index) => (
//           <div key={index} className="bar-container">
//             <div 
//               className="bar" 
//               style={{ 
//                 height: `${(item.value / maxInventoryValue) * 100}%`,
//                 background: `hsl(${210 + (index * 20)}, 70%, 50%)`
//               }}
//             >
//               <span className="bar-value">${(item.value/1000).toFixed(0)}k</span>
//             </div>
//             <div className="bar-label">{item.month}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   // Financial Chart Component
//   const FinancialChart = () => (
//     <div className="chart-card">
//       <h3>💰 Financial Overview (CoGS vs Revenue)</h3>
//       <div className="dual-bar-chart">
//         {financialData.map((item, index) => (
//           <div key={index} className="dual-bar-container">
//             <div className="dual-bar-group">
//               <div 
//                 className="dual-bar cogs-bar" 
//                 style={{ height: `${(item.cogs / maxFinancialValue) * 100}%` }}
//               >
//                 <span className="bar-value">${(item.cogs/1000).toFixed(0)}k</span>
//               </div>
//               <div 
//                 className="dual-bar revenue-bar" 
//                 style={{ height: `${(item.revenue / maxFinancialValue) * 100}%` }}
//               >
//                 <span className="bar-value">${(item.revenue/1000).toFixed(0)}k</span>
//               </div>
//             </div>
//             <div className="bar-label">{item.month}</div>
//           </div>
//         ))}
//       </div>
//       <div className="legend">
//         <span><span className="legend-color cogs-color"></span> CoGS</span>
//         <span><span className="legend-color revenue-color"></span> Revenue</span>
//       </div>
//     </div>
//   );

//   // Data Table Component
//   const DataTable = () => (
//     <div className="table-container">
//       <div className="table-controls">
//         <input 
//           type="text" 
//           placeholder="🔍 Search by Outlet or ID..." 
//           className="search-input"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <select 
//           className="status-filter"
//           value={filterStatus}
//           onChange={(e) => setFilterStatus(e.target.value)}
//         >
//           <option value="All">All Status</option>
//           <option value="Completed">Completed</option>
//           <option value="Pending">Pending</option>
//           <option value="In Transit">In Transit</option>
//         </select>
//       </div>

//       <table className="data-table">
//         <thead>
//           <tr>
//             <th>Transaction ID</th>
//             <th>Outlet</th>
//             <th>Items</th>
//             <th>Value</th>
//             <th>Status</th>
//             <th>Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredData.map((item) => (
//             <tr key={item.id}>
//               <td><strong>{item.id}</strong></td>
//               <td>{item.outlet}</td>
//               <td>{item.items}</td>
//               <td>{item.value}</td>
//               <td>
//                 <span className="status-badge" style={{ backgroundColor: getStatusColor(item.status) }}>
//                   {item.status}
//                 </span>
//               </td>
//               <td>{item.date}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );

//   return (
//     <div className="dashboard-container">
//       {/* Header */}
//       <div className="dashboard-header">
//         <div className="header-left">
//           <h1>📊 Apic Operational ERP Dashboard</h1>
//           <p className="subtitle">Real-time Operations Monitor</p>
//         </div>
//         <div className="header-right">
//           <select className="month-selector" value={selectedMonth} onChange={handleMonthChange}>
//             <option>June 2026</option>
//             <option>July 2026</option>
//             <option>August 2026</option>
//           </select>
//           <button className="refresh-btn" onClick={() => window.location.reload()}>
//             ⟳ Refresh
//           </button>
//         </div>
//       </div>

//       {/* Loading State */}
//       {loading ? (
//         <div className="loading-spinner">
//           <div className="spinner"></div>
//           <p>Loading dashboard data...</p>
//         </div>
//       ) : (
//         <>
//           {/* KPI Section */}
//           <div className="kpi-grid">
//             <KPICard 
//               title="Total Transfers" 
//               value={kpiData.totalTransfers} 
//               icon="📦"
//               change="+12.5%"
//               changeType="positive"
//             />
//             <KPICard 
//               title="Total Value" 
//               value={kpiData.totalValue} 
//               icon="💰"
//               change="+8.3%"
//               changeType="positive"
//             />
//             <KPICard 
//               title="Open Orders" 
//               value={kpiData.openOrders} 
//               icon="📋"
//               change="-3.2%"
//               changeType="negative"
//             />
//             <KPICard 
//               title="Pending Approvals" 
//               value={kpiData.pendingApprovals} 
//               icon="⏳"
//               change="+5.7%"
//               changeType="warning"
//             />
//           </div>

//           {/* Charts Section */}
//           <div className="charts-grid">
//             <InventoryChart />
//             <FinancialChart />
//           </div>

//           {/* Data Table Section */}
//           <div className="table-section">
//             <h3>📋 Recent Transfer Events</h3>
//             <DataTable />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;



import React, { useState, useEffect, useMemo } from 'react';
import {
  AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Legend
} from 'recharts';
import {
  Package, IndianRupee, ClipboardList, Clock, Search, RefreshCw, Bell,
  LayoutDashboard, Boxes, Wallet, Truck, FileBarChart, Settings, ChevronDown,
  ArrowUpRight, ArrowDownRight, AlertTriangle, Building2
} from 'lucide-react';

// ---------------------------------------------------------------------------
// Apic Operational ERP — Command Deck
// Palette: deep ledger navy (#132A46) + brass accent (#C8963E) on a cool
// paper-grey canvas. Numbers run in a monospace face throughout — this is a
// dashboard built around figures, so the figures should look like figures.
// ---------------------------------------------------------------------------

const NAV_ITEMS = [
  { icon: LayoutDashboard, label: 'Dashboard', active: true },
  { icon: Boxes, label: 'Inventory' },
  { icon: Truck, label: 'Transfers' },
  { icon: Wallet, label: 'Finance' },
  { icon: FileBarChart, label: 'Reports' },
  { icon: Settings, label: 'Settings' },
];

const fmtINRShort = (n) => {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(0)}k`;
  return `₹${n}`;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div style={{
      background: '#132A46', color: '#F4F6F8', padding: '10px 14px',
      borderRadius: 6, fontSize: 12, fontFamily: "'IBM Plex Mono', monospace",
      boxShadow: '0 8px 24px rgba(19,42,70,0.35)', border: '1px solid #24405f'
    }}>
      <div style={{ fontFamily: "'Space Grotesk', sans-serif", marginBottom: 6, color: '#C8963E', letterSpacing: 0.5 }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}>
          <span style={{ color: '#9FB0C3' }}>{p.name}</span>
          <span>{fmtINRShort(p.value)}</span>
        </div>
      ))}
    </div>
  );
};

const KPICard = ({ icon: Icon, title, value, delta, deltaType, accent }) => {
  const deltaColor = deltaType === 'up' ? '#1F8A5F' : deltaType === 'down' ? '#B23A3A' : '#B8752E';
  const DeltaIcon = deltaType === 'up' ? ArrowUpRight : deltaType === 'down' ? ArrowDownRight : AlertTriangle;
  return (
    <div style={{
      background: '#FFFFFF', borderRadius: 10, padding: '20px 22px',
      border: '1px solid #E5E8EC', position: 'relative', overflow: 'hidden',
      boxShadow: '0 1px 2px rgba(19,42,70,0.04)'
    }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: accent }} />
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <div style={{
            fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, fontWeight: 600,
            color: '#6B7686', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 10
          }}>{title}</div>
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 28, fontWeight: 600,
            color: '#132A46', fontVariantNumeric: 'tabular-nums'
          }}>{value}</div>
        </div>
        <div style={{
          width: 38, height: 38, borderRadius: 9, background: `${accent}1A`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
        }}>
          <Icon size={18} color={accent} strokeWidth={2} />
        </div>
      </div>
      <div style={{
        marginTop: 12, display: 'flex', alignItems: 'center', gap: 4,
        fontFamily: "'IBM Plex Mono', monospace", fontSize: 12.5, color: deltaColor, fontWeight: 500
      }}>
        <DeltaIcon size={13} />
        {delta}
        <span style={{ color: '#9AA3B0', fontFamily: "'Inter', sans-serif", marginLeft: 2 }}>vs last month</span>
      </div>
    </div>
  );
};

const StatusPill = ({ status }) => {
  const map = {
    Completed: { bg: '#E8F4EE', fg: '#1F8A5F' },
    Pending: { bg: '#FBF0E2', fg: '#B8752E' },
    'In Transit': { bg: '#E9EFF7', fg: '#2C5C93' },
  };
  const c = map[status] || { bg: '#EEE', fg: '#666' };
  return (
    <span style={{
      background: c.bg, color: c.fg, padding: '4px 10px', borderRadius: 20,
      fontSize: 11.5, fontWeight: 600, fontFamily: "'Space Grotesk', sans-serif",
      letterSpacing: '0.02em', whiteSpace: 'nowrap'
    }}>{status}</span>
  );
};

const Skeleton = ({ h = 16, w = '100%', r = 4 }) => (
  <div style={{
    height: h, width: w, borderRadius: r, background: 'linear-gradient(90deg,#EBEDF0 25%,#F5F6F8 37%,#EBEDF0 63%)',
    backgroundSize: '400% 100%', animation: 'apic-shimmer 1.4s ease infinite'
  }} />
);

export default function ApicErpDashboard() {
  const [kpiData, setKpiData] = useState(null);
  const [inventoryData, setInventoryData] = useState([]);
  const [financialData, setFinancialData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState('July 2026');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      setKpiData({
        totalTransfers: 1247,
        totalValue: 24800000,
        openOrders: 86,
        pendingApprovals: 23,
      });

      setInventoryData([
        { month: 'Jan', value: 1850000 },
        { month: 'Feb', value: 1920000 },
        { month: 'Mar', value: 1780000 },
        { month: 'Apr', value: 2050000 },
        { month: 'May', value: 2150000 },
        { month: 'Jun', value: 2340000 },
        { month: 'Jul', value: 2470000 },
      ]);

      setFinancialData([
        { month: 'Jan', cogs: 1250000, revenue: 2450000 },
        { month: 'Feb', cogs: 1320000, revenue: 2580000 },
        { month: 'Mar', cogs: 1180000, revenue: 2350000 },
        { month: 'Apr', cogs: 1450000, revenue: 2750000 },
        { month: 'May', cogs: 1520000, revenue: 2900000 },
        { month: 'Jun', cogs: 1680000, revenue: 3120000 },
        { month: 'Jul', cogs: 1750000, revenue: 3350000 },
      ]);

      setTransactions([
        { id: 'TR-1001', outlet: 'Mumbai Central', items: 245, value: 1245000, status: 'Completed', date: '2026-07-23' },
        { id: 'TR-1002', outlet: 'Delhi South', items: 189, value: 892000, status: 'Pending', date: '2026-07-23' },
        { id: 'TR-1003', outlet: 'Bangalore East', items: 312, value: 1567000, status: 'Completed', date: '2026-07-22' },
        { id: 'TR-1004', outlet: 'Chennai North', items: 156, value: 734000, status: 'In Transit', date: '2026-07-22' },
        { id: 'TR-1005', outlet: 'Hyderabad West', items: 278, value: 1328000, status: 'Completed', date: '2026-07-21' },
        { id: 'TR-1006', outlet: 'Pune East', items: 198, value: 945000, status: 'Pending', date: '2026-07-21' },
        { id: 'TR-1007', outlet: 'Ahmedabad North', items: 234, value: 1123000, status: 'Completed', date: '2026-07-20' },
      ]);
      setLoading(false);
    }, 1100);
    return () => clearTimeout(t);
  }, []);

  const filteredData = useMemo(() => transactions.filter((item) => {
    const q = searchTerm.toLowerCase();
    const matchesSearch = item.outlet.toLowerCase().includes(q) || item.id.toLowerCase().includes(q);
    const matchesStatus = filterStatus === 'All' || item.status === filterStatus;
    return matchesSearch && matchesStatus;
  }), [transactions, searchTerm, filterStatus]);

  return (
    <div style={{
      display: 'flex', minHeight: '100vh', background: '#F3F4F7',
      fontFamily: "'Inter', sans-serif", color: '#1A2233'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&family=IBM+Plex+Mono:wght@500;600&display=swap');
        * { box-sizing: border-box; }
        @keyframes apic-shimmer { 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } }
        ::-webkit-scrollbar { width: 8px; height: 8px; }
        ::-webkit-scrollbar-thumb { background: #C7CDD6; border-radius: 4px; }
        .apic-row:hover { background: #F7F8FA; }
        .apic-input:focus, .apic-select:focus { outline: 2px solid #C8963E; outline-offset: 1px; }
        .apic-btn:focus-visible { outline: 2px solid #C8963E; outline-offset: 2px; }
      `}</style>

      {/* Sidebar */}
      

      {/* Main */}
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        {/* Top bar */}
        <header style={{
          background: '#FFFFFF', borderBottom: '1px solid #E5E8EC', padding: '16px 28px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20
        }}>
          <div>
            <h1 style={{
              margin: 0, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600,
              fontSize: 19, color: '#132A46', letterSpacing: '-0.01em'
            }}>Operations Command Deck</h1>
            <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#7C8798' }}>Live inventory, transfers &amp; finance across all outlets</p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ position: 'relative' }}>
              <select
                className="apic-select"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                style={{
                  appearance: 'none', padding: '9px 32px 9px 14px', borderRadius: 8,
                  border: '1px solid #DCE0E6', background: '#FAFBFC', fontFamily: "'Inter',sans-serif",
                  fontSize: 13, fontWeight: 500, color: '#132A46', cursor: 'pointer'
                }}
              >
                <option>June 2026</option>
                <option>July 2026</option>
                <option>August 2026</option>
              </select>
              <ChevronDown size={14} style={{ position: 'absolute', right: 12, top: 11, pointerEvents: 'none', color: '#8891A0' }} />
            </div>

            <button className="apic-btn" style={{
              width: 36, height: 36, borderRadius: 8, border: '1px solid #DCE0E6', background: '#FAFBFC',
              display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', position: 'relative'
            }}>
              <Bell size={16} color="#132A46" />
              <span style={{ position: 'absolute', top: 7, right: 7, width: 6, height: 6, borderRadius: '50%', background: '#B23A3A' }} />
            </button>

            <button
              className="apic-btn"
              onClick={() => setLoading(true) || setTimeout(() => setLoading(false), 900)}
              style={{
                display: 'flex', alignItems: 'center', gap: 7, padding: '9px 16px', borderRadius: 8,
                border: 'none', background: '#132A46', color: '#F4F6F8', fontFamily: "'Space Grotesk',sans-serif",
                fontWeight: 600, fontSize: 13, cursor: 'pointer'
              }}
            >
              <RefreshCw size={14} />
              Refresh
            </button>
          </div>
        </header>

        {/* Content */}
        <main style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
          {/* KPI row */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: 16, marginBottom: 20 }}>
            {loading || !kpiData ? (
              Array.from({ length: 4 }).map((_, i) => (
                <div key={i} style={{ background: '#fff', borderRadius: 10, padding: 20, border: '1px solid #E5E8EC' }}>
                  <Skeleton w="60%" h={11} />
                  <div style={{ height: 14 }} />
                  <Skeleton w="45%" h={26} />
                  <div style={{ height: 12 }} />
                  <Skeleton w="70%" h={11} />
                </div>
              ))
            ) : (
              <>
                <KPICard icon={Package} title="Total Transfers" value={kpiData.totalTransfers.toLocaleString('en-IN')} delta="+12.5%" deltaType="up" accent="#2C5C93" />
                <KPICard icon={IndianRupee} title="Total Value" value={fmtINRShort(kpiData.totalValue)} delta="+8.3%" deltaType="up" accent="#C8963E" />
                <KPICard icon={ClipboardList} title="Open Orders" value={kpiData.openOrders} delta="-3.2%" deltaType="down" accent="#1F8A5F" />
                <KPICard icon={Clock} title="Pending Approvals" value={kpiData.pendingApprovals} delta="+5.7%" deltaType="flag" accent="#B8752E" />
              </>
            )}
          </div>

          {/* Charts row */}
          <div style={{ display: 'grid', gridTemplateColumns: '1.1fr 1fr', gap: 16, marginBottom: 20 }}>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #E5E8EC', padding: '20px 22px' }}>
              <h3 style={{
                margin: '0 0 16px', fontFamily: "'Space Grotesk',sans-serif", fontSize: 14.5,
                fontWeight: 600, color: '#132A46', display: 'flex', alignItems: 'center', gap: 8
              }}><Boxes size={16} color="#C8963E" /> Inventory Value Transferred Out</h3>
              {loading ? <Skeleton h={220} r={8} /> : (
                <ResponsiveContainer width="100%" height={220}>
                  <AreaChart data={inventoryData} margin={{ top: 4, right: 8, left: -18, bottom: 0 }}>
                    <defs>
                      <linearGradient id="invGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#C8963E" stopOpacity={0.35} />
                        <stop offset="100%" stopColor="#C8963E" stopOpacity={0.02} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid stroke="#EEF0F3" vertical={false} />
                    <XAxis dataKey="month" tick={{ fontSize: 11.5, fill: '#8891A0', fontFamily: 'Inter' }} axisLine={{ stroke: '#E5E8EC' }} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#8891A0', fontFamily: 'IBM Plex Mono' }} tickFormatter={fmtINRShort} axisLine={false} tickLine={false} />
                    <Tooltip content={<CustomTooltip />} />
                    <Area type="monotone" dataKey="value" name="Inventory" stroke="#C8963E" strokeWidth={2.5} fill="url(#invGradient)" dot={{ r: 3, fill: '#C8963E' }} />
                  </AreaChart>
                </ResponsiveContainer>
              )}
            </div>

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #E5E8EC', padding: '20px 22px' }}>
              <h3 style={{
                margin: '0 0 16px', fontFamily: "'Space Grotesk',sans-serif", fontSize: 14.5,
                fontWeight: 600, color: '#132A46', display: 'flex', alignItems: 'center', gap: 8
              }}><Wallet size={16} color="#2C5C93" /> Financial Overview — CoGS vs Revenue</h3>
              {loading ? <Skeleton h={220} r={8} /> : (
                <ResponsiveContainer width="100%" height={220}>
                  <BarChart data={financialData} margin={{ top: 4, right: 8, left: -18, bottom: 0 }} barGap={4}>
                    <CartesianGrid stroke="#EEF0F3" vertical={false} />
                    <XAxis dataKey="month" tick={{ fontSize: 11.5, fill: '#8891A0', fontFamily: 'Inter' }} axisLine={{ stroke: '#E5E8EC' }} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#8891A0', fontFamily: 'IBM Plex Mono' }} tickFormatter={fmtINRShort} axisLine={false} tickLine={false} />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend wrapperStyle={{ fontSize: 12, fontFamily: 'Inter' }} />
                    <Bar dataKey="cogs" name="CoGS" fill="#B23A3A" radius={[3, 3, 0, 0]} />
                    <Bar dataKey="revenue" name="Revenue" fill="#132A46" radius={[3, 3, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </div>
          </div>

          {/* Table */}
          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #E5E8EC', overflow: 'hidden' }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px',
              borderBottom: '1px solid #EEF0F3', flexWrap: 'wrap', gap: 12
            }}>
              <h3 style={{ margin: 0, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14.5, fontWeight: 600, color: '#132A46' }}>
                Recent Transfer Events
              </h3>
              <div style={{ display: 'flex', gap: 10 }}>
                <div style={{ position: 'relative' }}>
                  <Search size={14} style={{ position: 'absolute', left: 11, top: 10, color: '#9AA3B0' }} />
                  <input
                    className="apic-input"
                    placeholder="Search outlet or ID…"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: '8px 12px 8px 32px', borderRadius: 8, border: '1px solid #DCE0E6',
                      background: '#FAFBFC', fontSize: 13, width: 210, fontFamily: "'Inter',sans-serif"
                    }}
                  />
                </div>
                <select
                  className="apic-select"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  style={{
                    padding: '8px 12px', borderRadius: 8, border: '1px solid #DCE0E6',
                    background: '#FAFBFC', fontSize: 13, fontFamily: "'Inter',sans-serif", cursor: 'pointer'
                  }}
                >
                  <option value="All">All status</option>
                  <option value="Completed">Completed</option>
                  <option value="Pending">Pending</option>
                  <option value="In Transit">In Transit</option>
                </select>
              </div>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
                <thead>
                  <tr style={{ background: '#FAFBFC' }}>
                    {['Transaction ID', 'Outlet', 'Items', 'Value', 'Status', 'Date'].map((h) => (
                      <th key={h} style={{
                        textAlign: 'left', padding: '11px 20px', fontFamily: "'Space Grotesk',sans-serif",
                        fontSize: 11, fontWeight: 600, color: '#7C8798', textTransform: 'uppercase',
                        letterSpacing: '0.05em', borderBottom: '1px solid #EEF0F3'
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={i}>
                        {Array.from({ length: 6 }).map((__, j) => (
                          <td key={j} style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6' }}><Skeleton h={13} /></td>
                        ))}
                      </tr>
                    ))
                  ) : filteredData.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ padding: '32px 20px', textAlign: 'center', color: '#9AA3B0', fontSize: 13 }}>
                        No transfers match this search or filter.
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item) => (
                      <tr key={item.id} className="apic-row">
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6', fontFamily: "'IBM Plex Mono',monospace", fontWeight: 600, color: '#132A46' }}>{item.id}</td>
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6' }}>{item.outlet}</td>
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6', fontFamily: "'IBM Plex Mono',monospace" }}>{item.items}</td>
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6', fontFamily: "'IBM Plex Mono',monospace", fontWeight: 500 }}>{fmtINRShort(item.value)}</td>
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6' }}><StatusPill status={item.status} /></td>
                        <td style={{ padding: '13px 20px', borderBottom: '1px solid #F3F4F6', color: '#7C8798', fontFamily: "'IBM Plex Mono',monospace", fontSize: 12.5 }}>{item.date}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}